module.exports = __webpack_public_path__ + "assets/img/de-151d71dd.png";